import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Building } from "../../../services/building.service";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-building
                        [item]="data.building"
                        (saved)="onSaved()"
                        (cancelled)="onCancelled()"
                    ></s25-ng-building>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditBuildingComponent
    extends ModalComponent<{
        building: Building;
        reference?: string;
        onSave?: () => unknown;
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.onSave?.();
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
